import Textarea from "../../../../components/Input/Textarea";

function LongText({id, formik, settings}) {
    return (
        <Textarea
            name={id}
            label={settings.title}
            required={settings.required}
            description={settings.description}
            formik={formik}
            layout="vertical"
            inputWrapperClassName="long-text"
        />
    )
}

export default LongText
